import React, { Component } from 'react'

import Subjects from './subjects'
import Info from './info'
import Billing from './billing'

import Logo from 'assets/img/bisu-logo-sm.png'

class Data extends Component {
  componentDidMount() {
    // window.print()
  }

  render() {
    const advising = this.props.data.get('advising')
    const subjects = this.props.data.get('subjects')
    const billing = this.props.data.get('billing')
    const cor_url = this.props.data.get('cor_url')

    return (
      <div className="cor container">
        <table className="cor-head">
          <tbody>
            <tr>
              <td width="70">
                <img src={Logo} width="70" alt="BISU LOGO" className="logo" />
              </td>
              <td>
                Republic of the Philippines<br />
                <strong>BOHOL ISLAND STATE UNIVERSITY</strong>
                <br />
                <em>Main Campus</em>
                <br />
                CPG. Avenue, Tagbilaran City, Bohol, Philippines
              </td>
              <td width="200" className="text-right vbottom">
                <strong>Office of the Registrar</strong>
                <br />
                <small>
                  <em>registrar.main@bisu.edu.ph</em>
                </small>
                <br />
                <small>
                  <em>RO DOC 1</em>
                </small>
              </td>
            </tr>
            <tr>
              <td className="text-center" colSpan="3">
                <div className="title">CERTIFICATE OF REGISTRATION</div>
                SY {advising.get('sy')} , Term {advising.get('sem')}
              </td>
            </tr>
          </tbody>
        </table>
        <Info advising={advising} />
        <Subjects subjects={subjects} advising={advising} />
        <Billing billing={billing} advising={advising} corUrl={cor_url} />
      </div>
    )
  }
}

export default Data



// WEBPACK FOOTER //
// ./src/containers/COR2/data.js